import { Link } from "react-router-dom";
import { ListChecks } from "lucide-react";
import { useDueCounts } from "features/crm/modal/useDueCounts";
import { conversationsPath, dueTodayPath } from "features/crm/api/OutreachTouchesApi";

/** "LinkedIn due today" card: counts per kind of touch, overdue in a warning colour, links to the due-today page. */
export default function DueTodayCard() {
  const { counts } = useDueCounts(true);
  if (!counts) return null;
  const rows: [string, number][] = [
    ["Requests to send", counts.requests_to_send],
    ["Requests to check", counts.requests_to_check],
    ["Messages", counts.messages],
    ["Follow-ups", counts.follow_ups],
    ["Need a profile or person", counts.needs],
    ["Replies waiting on us", counts.conversations_waiting_on_us ?? 0],
    ["No answer yet", counts.conversations_no_answer ?? 0],
    ["Warm companies to write to", counts.warm_leads ?? 0],
  ];
  const replies = (counts.conversations_waiting_on_us ?? 0) + (counts.conversations_no_answer ?? 0);
  return (
    <div data-testid="due-today-card">
      <h2 className="text-base font-bold text-foreground font-inter mb-3 flex items-center gap-2">
        <ListChecks className="w-4 h-4 text-primary" />
        LinkedIn due today
      </h2>
      <Link to={counts.due_total === 0 && (counts.warm_leads ?? 0) === 0 && replies > 0 ? conversationsPath(counts.conversations_waiting_on_us ? "waiting=us" : "quiet=1") : dueTodayPath()} className="block rounded-2xl border border-border bg-surface p-4 hover:bg-surface-muted transition-colors">
        {counts.due_total === 0 && replies === 0 && (counts.warm_leads ?? 0) === 0 ? (
          <p className="text-sm text-muted-foreground font-inter">Nothing due today.</p>
        ) : (
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {rows.filter(([, n]) => n > 0).map(([label, n]) => (
              <div key={label}>
                <p className="text-xl font-bold text-foreground font-inter">{n}</p>
                <p className="text-xs text-muted-foreground font-inter">{label}</p>
              </div>
            ))}
            {counts.overdue > 0 && (
              <div>
                <p className="text-xl font-bold text-warning font-inter">{counts.overdue}</p>
                <p className="text-xs text-warning font-inter">Overdue</p>
              </div>
            )}
          </div>
        )}
        {counts.waiting_for_start > 0 && (
          <p className="text-xs text-muted-foreground font-inter mt-2">{counts.waiting_for_start} waiting for a campaign to start.</p>
        )}
      </Link>
    </div>
  );
}
